import { apiClient } from './client';

export interface AuthUser {
  email: string;
  /** Настоящее имя администратора (из старой админки, SSO его не хранит). null, если не удалось подтянуть. */
  name: string | null;
  /**
   * Включённые права — по ним прячутся недоступные разделы и действия
   * (см. usePermissions). Это только интерфейс: каждый маршрут /admin-api
   * проверяет право сам. Пустой массив, если старая админка недоступна.
   */
  permissions: string[];
}

/** Кто сейчас залогинен (по httpOnly-cookie BFF). 401 → не авторизован. */
export async function fetchMe(): Promise<AuthUser> {
  const { data } = await apiClient.get<AuthUser>('/auth/me');
  return data;
}

/** Выход: BFF удалит сессионную cookie. */
export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}
